import React from "react";
import { Form } from "@redriver/cinnamon";
import { getDocumentTypes } from "./actions";

export const DocumentTypesDropdown = ({ ...props }) => (
  <Form.Dropdown
    {...props}
    lookupAction={getDocumentTypes}
    lookupParams={{ departmentId: props.departmentId }}
  />
);

export default DocumentTypesDropdown;
